"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectiveStatus = exports.ObjectiveType = void 0;
// === Objective enums ===
var ObjectiveType;
(function (ObjectiveType) {
    ObjectiveType["MORTGAGE_BORROWER_UNDERWRITING_NEEDS_LIST"] = "MORTGAGE_BORROWER_UNDERWRITING_NEEDS_LIST";
    ObjectiveType["MORTGAGE_BORROWER_AUTH_SIGNING"] = "MORTGAGE_BORROWER_AUTH_SIGNING";
})(ObjectiveType || (exports.ObjectiveType = ObjectiveType = {}));
var ObjectiveStatus;
(function (ObjectiveStatus) {
    ObjectiveStatus["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    // Not ready, but applicable
    ObjectiveStatus["UPCOMING"] = "UPCOMING";
    ObjectiveStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ObjectiveStatus["COMPLETED"] = "COMPLETED";
})(ObjectiveStatus || (exports.ObjectiveStatus = ObjectiveStatus = {}));
